import { render, staticRenderFns } from "./syslist.vue?vue&type=template&id=857c87c2&scoped=true"
import script from "./syslist.vue?vue&type=script&lang=js"
export * from "./syslist.vue?vue&type=script&lang=js"
import style0 from "./syslist.vue?vue&type=style&index=0&id=857c87c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857c87c2",
  null
  
)

export default component.exports